import React, {useEffect, useState} from 'react';
import {Column} from '@ant-design/plots';
import {DatePicker} from "antd";
import {API_PATH} from "../../components/const";
import dayjs from "dayjs";
import Pie1 from "./Pie1";
import Pie2 from "./Pie2";
import ServiceTime2 from "./ServiceTime2";
import ServiceTime1 from "./ServiceTime1";

const ServiceTime = () => {

    return (
        <div className="visitor visitor-box">
            <ServiceTime1 />

            {/*<ServiceTime2 />*/}
            <div className="row">
                <div className="col-md-6">
                        {/*<Pie1 />*/}
                </div>
                <div className="col-md-6">
                    {/*<Pie2 />*/}
                </div>
            </div>
        </div>
    );
};
export default ServiceTime;